<template>
<div class="member-house">
  <div class="member-house-header">
    <el-input size="mini" v-model="where.keyword" placeholder="请输入房产/名称/电话" style="width: 200px;" @change="pageChange(1)"></el-input>

    <el-select size="mini" v-model="where.status" placeholder="请选择状态" style="width: 120px;" clearable filterable @change="pageChange(1)">
      <el-option label="待审核" value="0"></el-option>
      <el-option label="拒绝" value="1"></el-option>
      <el-option label="已审核" value="2"></el-option>
    </el-select>

    <el-select size="mini" v-model="where.room_status" placeholder="请选择房态" style="width: 120px;" clearable filterable @change="pageChange(1)">
      <el-option label="空置" value="1"></el-option>
      <el-option label="未领" value="2"></el-option>
      <el-option label="空关" value="3"></el-option>
      <el-option label="装修" value="4"></el-option>
      <el-option label="入住" value="5"></el-option>
      <el-option label="出租" value="6"></el-option>
      <el-option label="停用" value="7"></el-option>
    </el-select>
    <el-select size="mini" v-model="where.identity_type" placeholder="请选择身份" style="width: 120px;" clearable filterable @change="pageChange(1)">
      <el-option label="业主" value="1"></el-option>
      <el-option label="租户" value="2"></el-option>
      <el-option label="住户" value="3"></el-option>
    </el-select>

    <el-button size="mini" type="primary" @click="getList">查询</el-button>
    <el-button size="mini" type="primary" @click="exportExcel()">导出明细</el-button>
  </div>
  <div class="member-house-body">
    <el-table :data="pageData.data" v-loading="loading" border height="calc(100vh - 350px)">
      <el-table-column prop="project_house_name" label="项目" width="200" align="center" fixed></el-table-column>
      <el-table-column prop="house_name" label="房产" min-width="280" align="center" fixed></el-table-column>
      <el-table-column prop="house_status" label="房态" width="80" align="center">
        <template slot-scope="scope">
          {{house_status_map[scope.row.house_status]||'未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="member_nickname" label="微信昵称" width="120" align="center"></el-table-column>
      <el-table-column prop="member_telphone" label="微信电话" width="120" align="center"></el-table-column>
      <el-table-column prop="house_telphone" label="房产电话" width="120" align="center"></el-table-column>
      <el-table-column prop="identity" label="身份" width="80" align="center">
        <template slot-scope="scope">
          {{identity_map[scope.row.identity]||'未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="review_status" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.review_status === 0" type="info">待审核</el-tag>
          <el-tag v-if="scope.row.review_status === 1" type="danger">拒绝</el-tag>
          <el-tag v-if="scope.row.review_status === 2" type="success">已审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="butler_name" label="审核人" width="100" align="center"></el-table-column>
      <el-table-column prop="updated_at" label="认证时间" width="180" align="center">
        <template slot-scope="scope">
          {{scope.row.updated_at}}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="提交时间" width="180" align="center">
        <template slot-scope="scope">
          {{scope.row.created_at}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="ERP.isPermission(1701001004)&&(scope.row.review_status===0||scope.row.review_status===1)" type="primary" size="mini" @click="applyReview(scope.row)">同意</el-button>
          <el-button v-if="ERP.isPermission(1701001004)&&(scope.row.review_status===0)" type="danger" size="mini" @click="rejectReview(scope.row)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="project-ind-footer">
    <el-pagination
      @current-change="pageChange"
      :current-page="pageData.current_page"
      :page-size="pageData.per_page"
      layout="total, prev, pager, next"
      :total="pageData.total">
    </el-pagination>
  </div>

  <el-dialog :visible.sync="dialogVisible" width="500px" @closed="fromData={}" :close-on-click-modal="false" append-to-body>
    <el-descriptions column="1" border :label-style="{width: '80px'}">
      <el-descriptions-item label="项目">{{fromData.project_house_name}}</el-descriptions-item>
      <el-descriptions-item label="房产">{{fromData.house_name}}</el-descriptions-item>
      <el-descriptions-item label="房态">{{house_status_map[fromData.house_status]||'未知'}}</el-descriptions-item>
      <el-descriptions-item label="微信昵称">{{fromData.member_nickname}}</el-descriptions-item>
      <el-descriptions-item label="微信电话">{{fromData.member_telphone}}</el-descriptions-item>
      <el-descriptions-item label="房产电话">{{fromData.house_telphone}}</el-descriptions-item>
      <el-descriptions-item label="身份">
        <el-select v-model="fromData.identity" size="mini" placeholder="请选择" style="width: 100px">
          <el-option label="业主" :value="1"></el-option>
          <el-option label="租户" :value="2"></el-option>
          <el-option label="住户" :value="3"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
    <template slot="footer">
      <div style="text-align: right;">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="applyReview2">同 意</el-button>
      </div>
    </template>
  </el-dialog>
</div>
</template>

<script>
import ButlerHttp from "../common/ButlerHttp";
import moment from "moment";

export default {
  name: "MemberHouseReview",
  inject: ['reginWhere'],
  data() {
    return {
      where:{
        keyword:"",
        status:"0",
        room_status: "",
        identity_type:"",
        order_by:"",
      },
      loading: false,
      pageData:{
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      house_status_map:{
        1:"空置",
        2:"未领",
        3:"空关",
        4:"装修",
        5:"入住",
        6:"出租",
        7:"停用"
      },
      identity_map:{
        1:"业主",
        2:"租户",
        3:"住户"
      },
      fromData:{},
      dialogVisible:false,
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      where = {
        ...where,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
      }

      ButlerHttp.post("MemberHouseReview/index?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page, {
        ...where,
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.current_page = i
      this.getList()
    },
    applyReview(row){
      const that = this;
      that.fromData=row
      that.dialogVisible = true;
    },
    applyReview2(){
      const that = this;
      if(!that.fromData.member_id){
        that.$message.error("请选择用户")
        return;
      }
      if(!that.fromData.house_id){
        that.$message.error("请选择房产")
        return;
      }
      ButlerHttp.post("MemberHouseReview/review", {
        member_id:that.fromData.member_id,
        house_id:that.fromData.house_id,
        status:"2",
        identity:that.fromData.identity
      }, res => {
        that.dialogVisible = false;
        if (res.code) {
          that.$message.success("操作成功")
          that.getList()
        }else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    rejectReview(row){
      const that = this;
      that.$confirm('确定拒绝吗？', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("MemberHouseReview/review", {
          member_id:row.member_id,
          house_id:row.house_id,
          status:"1",
          identity:row.identity
        }, res => {
          if (res.code) {
            that.$message.success("操作成功")
            that.getList()
          }else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    exportExcel(){
      const that = this;
      let where = ERP.reJson(that.where)
      where = {
        ...where,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
      }

      ButlerHttp.post("MemberHouseReview/exportExcel", {
        ...where,
      }, res => {
        if (res.code) {
          window.open(res.data);
        }else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.area_id":function (n,o) {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.member-house {
  .member-house-header{
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
  }
  .member-house-body{

  }
  .project-ind-footer{
    text-align: center;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/MemberHouseReview.vue